// FRS 4.2.2 — ออพ.๐๑/๐๒
// Service ฟังก์ชันสำหรับ wizard สร้างเอกสาร (เรียกตรงผ่าน RestClient, คืน Promise)
import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

const FORM = Constants.API_FORM;

// list เอกสารของโครงการ
export const listForms = projectId =>
  RestClient.request({
    method: 'get',
    url: FORM,
    params: { project: projectId },
  });

// สร้างเอกสารใหม่ (bundle) — ขั้นที่ 1 ของ Wizard
export const createForm = (projectId, purpose) =>
  RestClient.request({
    method: 'post',
    url: FORM,
    data: { project: projectId, purpose },
  });

export const getForm = formId =>
  RestClient.request({ method: 'get', url: `${FORM}${formId}/` });

// ลบเอกสาร — เฉพาะสถานะ draft (backend ปฏิเสธถ้า locked)
export const deleteForm = formId =>
  RestClient.request({ method: 'delete', url: `${FORM}${formId}/` });

// AUTO data (read-only จาก BEC engine) — ขั้นที่ 3
export const getAutoData = formId =>
  RestClient.request({ method: 'get', url: `${FORM}${formId}/auto-data/` });

// MANUAL data — ขั้นที่ 2
export const getManualData = formId =>
  RestClient.request({ method: 'get', url: `${FORM}${formId}/manual-data/` });

export const saveManualData = (formId, payload) =>
  RestClient.request({
    method: 'put',
    url: `${FORM}${formId}/manual-data/`,
    data: payload,
  });

// Preview PDF (watermark DRAFT) — คืน blob URL สำหรับเปิด/embed
export const previewPdf = formId =>
  RestClient.request({
    method: 'get',
    url: `${FORM}${formId}/preview/`,
    responseType: 'blob',
  }).then(blob => URL.createObjectURL(blob));

// Submit (draft -> locked) + Bundle PDF
export const submitForm = formId =>
  RestClient.request({ method: 'post', url: `${FORM}${formId}/submit/` });

// Revoke (locked -> draft) — ต้องระบุเหตุผล
export const revokeForm = (formId, reason) =>
  RestClient.request({
    method: 'post',
    url: `${FORM}${formId}/revoke/`,
    data: { reason },
  });

export const getAuditLog = formId =>
  RestClient.request({ method: 'get', url: `${FORM}${formId}/audit-log/` });

export const getRenderAudit = formId =>
  RestClient.request({ method: 'get', url: `${FORM}${formId}/render-audit/` });



// WEBPACK FOOTER //
// ./src/redux/forms/forms_actions.js